import { render, staticRenderFns } from "./Aggregate.vue?vue&type=template&id=bb824ff2&scoped=true&"
import script from "./Aggregate.vue?vue&type=script&lang=js&"
export * from "./Aggregate.vue?vue&type=script&lang=js&"
import style0 from "./Aggregate.vue?vue&type=style&index=0&id=bb824ff2&prod&lang=css&"
import style1 from "./Aggregate.vue?vue&type=style&index=1&id=bb824ff2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb824ff2",
  null
  
)

export default component.exports